module.exports = __webpack_public_path__ + "static/7-5e2555213d74511ccd39a5e7c4f325e1.png";